import type { CrmMessages } from "./englishCrmMessages";

export const spanishCrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nombre de la empresa",
        website: "Sitio web",
        linkedin_url: "URL de LinkedIn",
        phone_number: "Teléfono",
        created_at: "Fecha de creación",
        nb_contacts: "Número de contactos",
        revenue: "Facturación",
        sector: "Sector",
        size: "Tamaño",
        tax_identifier: "Identificación fiscal",
        address: "Dirección",
        city: "Ciudad",
        zipcode: "Código postal",
        state_abbr: "Provincia",
        country: "País",
        description: "Descripción",
        context_links: "Enlaces de contexto",
        sales_id: "Responsable de cuenta",
      },
      empty: {
        description: "Parece que su lista de empresas está vacía.",
        title: "No se han encontrado empresas",
      },
      import: {
        title: "Importar empresas",
      },
      field_categories: {
        contact: "Contacto",
        additional_info: "Información adicional",
        address: "Dirección",
        context: "Contexto",
      },
      action: {
        create: "Crear empresa",
        edit: "Editar empresa",
        new: "Nueva empresa",
        show: "Ver empresa",
      },
      added_on: "Añadida el %{date}",
      followed_by: "Seguida por %{name}",
      followed_by_you: "Seguida por usted",
      no_contacts: "Sin contactos",
      nb_contacts: "%{smart_count} contacto |||| %{smart_count} contactos",
      nb_deals: "%{smart_count} oportunidad |||| %{smart_count} oportunidades",
      sizes: {
        one_employee: "1 empleado",
        two_to_nine_employees: "2-9 empleados",
        ten_to_forty_nine_employees: "10-49 empleados",
        fifty_to_two_hundred_forty_nine_employees: "50-249 empleados",
        two_hundred_fifty_or_more_employees: "250 empleados o más",
      },
      autocomplete: {
        create_error: "Se ha producido un error al crear la empresa",
        create_item: "Crear %{item}",
        create_label: "Empiece a escribir para crear una empresa nueva",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      field_categories: {
        background_info: "Información de contexto",
        identity: "Identidad",
        misc: "Varios",
        personal_info: "Datos personales",
        position: "Puesto",
      },
      fields: {
        first_name: "Nombre",
        last_name: "Apellidos",
        last_seen: "Última actividad",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Direcciones de correo",
        email: "Correo electrónico",
        phone_jsonb: "Números de teléfono",
        phone_number: "Teléfono",
        linkedin_url: "URL de LinkedIn",
        background: "Información de contexto (biografía, cómo se conocieron…)",
        has_newsletter: "Suscrito a la newsletter",
        sales_id: "Responsable de cuenta",
      },
      action: {
        add: "Añadir contacto",
        add_first: "Añada su primer contacto",
        create: "Crear contacto",
        edit: "Editar contacto",
        export_vcard: "Exportar a vCard",
        new: "Nuevo contacto",
        show: "Ver contacto",
      },
      background: {
        last_activity_on: "Última actividad el %{date}",
        added_on: "Añadido el %{date}",
        followed_by: "Seguido por %{name}",
        followed_by_you: "Seguido por usted",
        status_none: "Ninguno",
      },
      position_at: "%{title} en",
      position_at_company: "%{title} en %{company}",
      empty: {
        description: "Parece que su lista de contactos está vacía.",
        title: "No se han encontrado contactos",
      },
      import: {
        title: "Importar contactos",
      },
      inputs: {
        genders: {
          male: "Él",
          female: "Ella",
          nonbinary: "Elle",
        },
        personal_info_types: {
          work: "Trabajo",
          home: "Personal",
          other: "Otro",
        },
      },
      list: {
        error_loading: "Error al cargar los contactos",
      },
      bulk_tag: {
        action: "Etiquetar",
        back: "Volver a las etiquetas",
        create_description:
          "Cree una etiqueta nueva y aplíquela a los contactos seleccionados.",
        description:
          "Elija una etiqueta existente o cree una nueva para los contactos seleccionados.",
        empty:
          "Todavía no hay etiquetas. Cree una para etiquetar los contactos seleccionados.",
        error: "No se ha podido añadir la etiqueta a los contactos",
        noop: "Los contactos seleccionados ya tienen esta etiqueta",
        success:
          "Etiqueta añadida a %{smart_count} contacto |||| Etiqueta añadida a %{smart_count} contactos",
        title: "Añadir etiqueta a los contactos",
      },
      merge: {
        action: "Fusionar con otro contacto",
        confirm: "Fusionar contactos",
        current_contact: "Contacto actual (se eliminará)",
        description: "Fusione este contacto con otro.",
        error: "No se han podido fusionar los contactos",
        merging: "Fusionando...",
        no_additional_data: "No hay datos adicionales que fusionar",
        select_target: "Seleccione un contacto con el que fusionar",
        success: "Contactos fusionados correctamente",
        target_contact: "Contacto de destino (se conservará)",
        title: "Fusionar contacto",
        warning_description:
          "Todos los datos se transferirán al segundo contacto. Esta acción no se puede deshacer.",
        warning_title: "Atención: operación destructiva",
        what_will_be_merged: "Qué se va a fusionar:",
      },
      filters: {
        before_last_month: "Antes del mes pasado",
        before_this_month: "Antes de este mes",
        before_this_week: "Antes de esta semana",
        managed_by_me: "Gestionados por mí",
        search: "Buscar por nombre, empresa...",
        this_week: "Esta semana",
        today: "Hoy",
        tags: "Etiquetas",
        tasks: "Tareas",
      },
      hot: {
        empty_change_status:
          'Cambie el estado de un contacto añadiéndole una nota y haciendo clic en "Mostrar opciones".',
        empty_hint: 'Aquí aparecerán los contactos con estado "caliente".',
        title: "Contactos calientes",
      },
    },
    deals: {
      name: "Oportunidad |||| Oportunidades",
      fields: {
        name: "Nombre",
        description: "Descripción",
        company_id: "Empresa",
        contact_ids: "Contactos",
        category: "Categoría",
        amount: "Importe",
        expected_closing_date: "Fecha prevista de cierre",
        stage: "Etapa",
      },
      action: {
        back_to_deal: "Volver a la oportunidad",
        create: "Crear oportunidad",
        new: "Nueva oportunidad",
      },
      field_categories: {
        misc: "Varios",
      },
      filters: {
        only_mine: "Solo las oportunidades que gestiono",
      },
      archived: {
        action: "Archivar",
        error: "Error: la oportunidad no se ha archivado",
        list_title: "Oportunidades archivadas",
        success: "Oportunidad archivada",
        title: "Oportunidad archivada",
        view: "Ver oportunidades archivadas",
      },
      inputs: {
        linked_to: "Vinculada a",
      },
      unarchived: {
        action: "Devolver al tablero",
        error: "Error: la oportunidad no se ha desarchivado",
        success: "Oportunidad desarchivada",
      },
      updated: "Oportunidad actualizada",
      empty: {
        before_create: "antes de crear una oportunidad.",
        description: "Parece que su lista de oportunidades está vacía.",
        title: "No se han encontrado oportunidades",
      },
      import: {
        title: "Importar oportunidades",
      },
      invalid_date: "Fecha no válida",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Estado",
        date: "Fecha",
        attachments: "Adjuntos",
        contact_id: "Contacto",
        deal_id: "Oportunidad",
      },
      action: {
        add: "Añadir nota",
        add_first: "Añada su primera nota",
        delete: "Eliminar nota",
        edit: "Editar nota",
        update: "Actualizar nota",
        add_this: "Añadir esta nota",
      },
      sheet: {
        create: "Crear nota",
        create_for: "Crear nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota para %{name}",
      },
      deleted: "Nota eliminada",
      empty: "Todavía no hay notas",
      author_added: "%{name} ha añadido una nota",
      you_added: "Ha añadido una nota",
      me: "Yo",
      list: {
        error_loading: "Error al cargar las notas",
      },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Vaya a la ficha de un contacto y añada una nota",
      },
      added: "Nota añadida",
      inputs: {
        add_note: "Añadir una nota",
        options_hint: "(adjuntar archivos o cambiar los detalles)",
        show_options: "Mostrar opciones",
      },
      actions: {
        attach_document: "Adjuntar documento",
      },
      validation: {
        note_or_attachment_required: "Se requiere una nota o un adjunto",
      },
    },
    sales: {
      name: "Usuario |||| Usuarios",
      fields: {
        first_name: "Nombre",
        last_name: "Apellidos",
        email: "Correo electrónico",
        administrator: "Administrador",
        disabled: "Desactivado",
      },
      create: {
        error: "Se ha producido un error al crear el usuario.",
        success:
          "Usuario creado. Recibirá en breve un correo electrónico para establecer su contraseña.",
        title: "Crear un usuario nuevo",
      },
      edit: {
        error: "Se ha producido un error. Inténtelo de nuevo.",
        record_not_found: "Registro no encontrado",
        success: "Usuario actualizado correctamente",
        title: "Editar %{name}",
      },
      action: {
        new: "Nuevo usuario",
      },
    },
    tasks: {
      name: "Tarea |||| Tareas",
      forcedCaseName: "Tarea",
      fields: {
        text: "Descripción",
        due_date: "Fecha de vencimiento",
        type: "Tipo",
        contact_id: "Contacto",
        due_short: "vence",
      },
      action: {
        add: "Añadir tarea",
        create: "Crear tarea",
        edit: "Editar tarea",
      },
      actions: {
        postpone_next_week: "Posponer a la semana que viene",
        postpone_tomorrow: "Posponer a mañana",
        title: "acciones de la tarea",
      },
      added: "Tarea añadida",
      deleted: "Tarea eliminada correctamente",
      dialog: {
        create: "Crear tarea",
        create_for: "Crear tarea para %{name}",
      },
      sheet: {
        edit: "Editar tarea",
        edit_for: "Editar tarea para %{name}",
      },
      empty: "Todavía no hay tareas",
      empty_list_hint: "Aquí aparecerán las tareas añadidas a sus contactos.",
      filters: {
        later: "Más adelante",
        overdue: "Vencidas",
        this_week: "Esta semana",
        today: "Hoy",
        tomorrow: "Mañana",
        with_pending: "Con tareas pendientes",
      },
      regarding_contact: "(Ref.: %{name})",
      updated: "Tarea actualizada",
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: {
        add: "Añadir etiqueta",
        create: "Crear etiqueta nueva",
      },
      dialog: {
        color: "Color",
        create_title: "Crear una etiqueta nueva",
        edit_title: "Editar etiqueta",
        name_label: "Nombre de la etiqueta",
        name_placeholder: "Introduzca el nombre de la etiqueta",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Restablecer contraseña",
    },
    auth: {
      first_name: "Nombre",
      last_name: "Apellidos",
      confirm_password: "Confirmar contraseña",
      confirmation_required:
        "Siga el enlace que le acabamos de enviar por correo electrónico para confirmar su cuenta.",
      login_subtitle: "Acceda a su CRM",
      login_title: "Inicio de sesión seguro",
      or_divider: "o",
      recovery_email_sent:
        "Si es un usuario registrado, recibirá en breve un correo electrónico para recuperar su contraseña.",
      sign_in_failed: "No se ha podido iniciar sesión.",
      sign_in_google_workspace: "Iniciar sesión con Google Workplace",
      sign_in_oidc: "Iniciar sesión con Agentic360",
      signup: {
        create_account: "Crear cuenta",
        create_first_user:
          "Cree la primera cuenta de usuario para completar la configuración.",
        creating: "Creando...",
        initial_user_created: "Usuario inicial creado correctamente",
      },
      welcome_title: "Bienvenido a Atomic CRM",
    },
    common: {
      account_manager: "Responsable de cuenta",
      activity: "Actividad",
      added: "añadido",
      details: "Detalles",
      last_activity_with_date: "última actividad %{date}",
      load_more: "Cargar más",
      misc: "Varios",
      past: "Vencida",
      read_more: "Leer más",
      retry: "Reintentar",
      show_less: "Mostrar menos",
      copied: "¡Copiado!",
      copy: "Copiar",
      loading: "Cargando...",
      me: "Yo",
      task_count: "%{smart_count} tarea |||| %{smart_count} tareas",
    },
    changelog: {
      title: "Novedades",
    },
    activity: {
      added_company: "%{name} ha añadido la empresa",
      you_added_company: "Ha añadido la empresa",
      added_contact: "%{name} ha añadido a",
      you_added_contact: "Ha añadido a",
      added_note: "%{name} ha añadido una nota sobre",
      you_added_note: "Ha añadido una nota sobre",
      added_note_about_deal: "%{name} ha añadido una nota sobre la oportunidad",
      you_added_note_about_deal: "Ha añadido una nota sobre la oportunidad",
      added_deal: "%{name} ha añadido la oportunidad",
      you_added_deal: "Ha añadido la oportunidad",
      at_company: "en",
      to: "a",
      load_more: "Cargar más actividad",
    },
    dashboard: {
      deals_chart: "Ingresos previstos de oportunidades",
      deals_pipeline: "Pipeline de oportunidades",
      latest_activity: "Última actividad",
      latest_activity_error: "Error al cargar la última actividad",
      latest_notes: "Mis últimas notas",
      latest_notes_added_ago: "añadida %{timeAgo}",
      stepper: {
        install: "Instalar Atomic CRM",
        progress: "%{step}/3 completado",
        whats_next: "¿Y ahora qué?",
      },
      upcoming_tasks: "Próximas tareas",
    },
    data_import: {
      button: "Importar CSV",
      complete:
        "Importación finalizada. Se han importado %{importCount} registros, con %{errorCount} errores",
      csv_file: "Archivo CSV",
      error:
        "No se ha podido importar este archivo; compruebe que se trata de un archivo CSV válido.",
      progress:
        "Se han importado %{importCount} / %{rowCount} registros, con %{errorCount} errores.",
      remaining_time: "Tiempo restante estimado:",
      resource: "Recurso",
      running: "La importación está en curso; no cierre esta pestaña.",
      sample_download: "Descargar CSV de ejemplo",
      sample_hint:
        "Este es un archivo CSV de ejemplo que puede usar como plantilla",
      start: "Iniciar importación",
      stop: "Detener importación",
      title: "Importar datos",
    },
    header: {
      import_data: "Importar desde JSON",
    },
    image_editor: {
      change: "Cambiar",
      drop_hint:
        "Suelte un archivo para subirlo o haga clic para seleccionarlo.",
      editable_content: "Contenido editable",
      title: "Subir y redimensionar la imagen",
      update_image: "Actualizar imagen",
    },
    import: {
      action: {
        download_error_report: "Descargar el informe de errores",
        import: "Importar",
        import_another: "Importar otro archivo",
      },
      error: {
        unable: "No se ha podido importar este archivo.",
      },
      idle: {
        description_1:
          "Puede importar usuarios, empresas, contactos, notas y tareas.",
        description_2:
          "Los datos deben estar en un archivo JSON con el siguiente formato:",
      },
      status: {
        all_success: "Todos los registros se han importado correctamente.",
        complete: "Importación finalizada.",
        failed: "Con errores",
        imported: "Importados",
        in_progress: "Importación en curso; no abandone esta página.",
        some_failed: "Algunos registros no se han importado.",
        table_caption: "Estado de la importación",
      },
      title: "Importar desde JSON",
    },
    settings: {
      about: "Acerca de",
      companies: {
        sectors: "Sectores",
      },
      dark_mode_logo: "Logotipo para el modo oscuro",
      deals: {
        categories: "Categorías",
        currency: "Moneda",
        pipeline_help:
          "Seleccione qué etapas de las oportunidades deben contar como oportunidades del pipeline.",
        pipeline_statuses: "Estados del pipeline",
        stages: "Etapas",
      },
      light_mode_logo: "Logotipo para el modo claro",
      notes: {
        statuses: "Estados",
      },
      reset_defaults: "Restaurar valores predeterminados",
      save_error: "No se ha podido guardar la configuración",
      saved: "Configuración guardada correctamente",
      saving: "Guardando...",
      tasks: {
        types: "Tipos",
      },
      preferences: "Preferencias",
      title: "Configuración",
      app_title: "Título de la aplicación",
      sections: {
        branding: "Marca",
      },
      validation: {
        duplicate: "Valores duplicados en %{display_name}: %{items}",
        in_use:
          "No se pueden eliminar %{display_name} que todavía están en uso por oportunidades: %{items}",
        validating: "Validando…",
        entities: {
          categories: "categorías",
          stages: "etapas",
        },
      },
    },
    theme: {
      dark: "Oscuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    navigation: {
      label: "Navegación del CRM",
    },
    profile: {
      inbound: {
        description:
          "Puede empezar a enviar correos a la dirección de entrada de su servidor, por ejemplo añadiéndola al campo %{field}. Atomic CRM procesará los correos y añadirá notas a los contactos correspondientes.",
        title: "Correo entrante",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Use esta URL para conectar su asistente de IA a los datos de su CRM mediante el Model Context Protocol (MCP).",
      },
      password: {
        change: "Cambiar contraseña",
      },
      password_reset_sent:
        "Se ha enviado un correo electrónico para restablecer la contraseña a su dirección",
      record_not_found: "Registro no encontrado",
      title: "Perfil",
      updated: "Su perfil se ha actualizado",
      update_error: "Se ha producido un error. Inténtelo de nuevo",
    },
    validation: {
      invalid_url: "Debe ser una URL válida",
      invalid_linkedin_url: "La URL debe ser de linkedin.com",
    },
  },
} satisfies CrmMessages;
